import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { reactive, computed } from 'vue'
import { useRoute } from 'vue-router'
import { Tabs, Tab } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'MTabsSwipe',
  props: {
  modelValue: { type: Number, default: -1 },
  tabs: { type: Array, default: () => [] },
  skin: { type: String, default: '' }, // 预设主题 space-around 按内容均分
},
  emits: ['change'],
  setup(__props, { emit: emits }) {

const props = __props;




const route = useRoute()
const state = reactive({
  tabs: [],
  tabsActive: 0,
})

const tabsActive = computed({
  get: () => props.modelValue,
  set: (newValue) => emits('update:modelValue', newValue),
})

const handleChange = (value) => {
  console.log('change value ==>', value)
  emits('update:modelValue', value)
  emits('change', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tabs-swipe", props.skin])
  }, [
    _createVNode(_unref(Tabs), {
      active: _unref(tabsActive),
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabsActive) ? (tabsActive).value = $event : null)),
      onChange: handleChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (item) => {
          return (_openBlock(), _createBlock(_unref(Tab), {
            title: item.title,
            key: item.title
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", { tabsActive: _unref(tabsActive) })
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128))
      ]),
      _: 3
    }, 8, ["active"])
  ], 2))
}
}

})